(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7307],{

/***/ 7573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/education-loan-for-overseas-education",
      function () {
        return __webpack_require__(9944);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 3011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70710);










const FaqComponent = (props)=>{
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showCardDetail , 1: setShowCardDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faqComponent),
        style: {
            backgroundColor: props.sectionBgColor || "#EFEFFA"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-center",
                                    children: props.title
                                }),
                                props.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: props.description
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle2
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: props.subTitle3
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                            children: props.faqPoints?.length > 0 && props.faqPoints.map((faqsdata, index)=>{
                                const condition = !isViewMore ? index < 5 : index >= 0;
                                const key = index.toString();
                                return condition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 8,
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        activeKey: showCardDetail,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                            eventKey: key,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                    onClick: ()=>{
                                                        if (showCardDetail === key) {
                                                            setShowCardDetail(null);
                                                        } else {
                                                            setShowCardDetail(key);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            style: {
                                                                color: ` ${showCardDetail === key ? "#0c63e4" : "#201f22"}`
                                                            },
                                                            children: [
                                                                " ",
                                                                faqsdata.title
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: faqsdata.description
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        }),
                        props.faqPoints?.length > 5 && !isViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-4 mb-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    id: "faq-component",
                                    onClick: ()=>{
                                        setIsViewMore(true);
                                    },
                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                                    children: "View More"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqComponent);


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82908);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70710);













const Testimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: centerSlide , 1: setCenterSlide  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const settings = {
        dotsClass: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sliderDots),
        dots: false,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        initialSlide: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 200
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        id: "studenttestimonial",
        className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().studentTestSlider),
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "studentmm",
                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().student),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)}`,
                                    children: testimonialData.map((slide, ind)=>{
                                        return ind < 15 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stuTestCard)}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "33",
                                                            height: "22",
                                                            viewBox: "0 0 33 22",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                    fill: "#226CF5"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                    fill: "#226CF5"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "my-4",
                                                            children: slide?.testimonial?.message
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "mb-0",
                                                            children: slide?.testimonial?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().addre),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.details
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.subDetails
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, ind);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Testimonial);


/***/ }),

/***/ 9944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ education_loan_for_overseas_education; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/educationloan.module.scss
var educationloan_module = __webpack_require__(31171);
var educationloan_module_default = /*#__PURE__*/__webpack_require__.n(educationloan_module);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Ratio.js
var Ratio = __webpack_require__(84883);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
;// CONCATENATED MODULE: ./components/EduationLoan.tsx




















const EducationLoan = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "education-loan",
                className: (educationloan_module_default()).dynamicBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationloan_module_default()).mainSectionBg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationloan_module_default()).contentDiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        lg: 6,
                                        md: 6,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-block d-sm-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                            className: (educationloan_module_default()).mobileBreadCrum,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: "/",
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: "Home"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: "",
                                                                    children: "Education loans"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: props.pageData?.mainImageUrl,
                                                        alt: props.pageData?.mainImageAltTag,
                                                        width: 540,
                                                        height: 400
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (educationloan_module_default()).servContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: "d-none d-sm-block",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "/",
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "Education loans"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: props.pageData?.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: props.pageData?.description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "primary",
                                                        size: "lg",
                                                        className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(props.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                        onClick: ()=>{
                                                            !props?.pageData?.meta?.jotforms[0]?.jotformid && router_default().push(props?.pageData?.externalLink);
                                                        },
                                                        children: props?.pageData?.bannerBtn?.label || "Enquiry Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        lg: 6,
                                        md: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-none d-sm-block text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: props.pageData?.mainImageUrl,
                                                alt: props.pageData?.mainImageAltTag,
                                                width: 600,
                                                height: 507
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "loan-processtop",
                className: (educationloan_module_default()).loanProcesstop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (educationloan_module_default())["loan-div-heading"],
                                    children: props.pageData?.loanDivision?.sectionTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 6,
                                    lg: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-block d-sm-none mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: props.pageData?.loanDivision?.sectionImageUrl || "/",
                                                alt: props.pageData?.loanDivision?.sectionImageAltTag,
                                                width: 490,
                                                height: 440
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (educationloan_module_default()).multi_country_content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    props.pageData?.loanDivision?.sectionDescription,
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 6,
                                    lg: 6,
                                    className: "d-none d-sm-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props.pageData?.loanDivision?.sectionImageUrl || "/",
                                            alt: props.pageData?.loanDivision?.sectionImageAltTag,
                                            width: 490,
                                            height: 440
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 6,
                                    lg: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-block d-sm-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: (educationloan_module_default()).titlebom2,
                                                children: props.pageData?.studyDreams?.sectionTitle
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: props.pageData?.studyDreams?.sectionImageUrl,
                                                alt: props.pageData?.studyDreams?.sectionImageAltTag,
                                                width: 490,
                                                height: 440
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 6,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (educationloan_module_default()).multi_country_content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-none d-sm-block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: (educationloan_module_default()).titlebom2,
                                                    children: props.pageData?.studyDreams?.sectionTitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: props.pageData?.studyDreams?.sectionDescription
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: props.pageData?.studyDreams?.sectionPoints.length > 0 && props.pageData.studyDreams.sectionPoints.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: point
                                                    }, index))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "loan-process",
                className: (educationloan_module_default()).loanProcess,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.pageData?.loanProcess?.sectionTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: props.pageData?.loanProcess?.sectionDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (educationloan_module_default()).centered,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                    children: props.pageData?.loanProcess?.loanProcessPoints?.length > 0 && props.pageData.loanProcess.loanProcessPoints.map((points, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (educationloan_module_default()).decimals,
                                                    children: index + 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: points.pointImageUrl,
                                                        alt: points.pointImageAltTag,
                                                        width: 70,
                                                        height: 70
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: points.point
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "searvice-loan",
                className: (educationloan_module_default()).searviceLoan,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "platform-content",
                                        className: (educationloan_module_default()).PlatformContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-block d-sm-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: (educationloan_module_default()).mobileh3,
                                                        children: props.pageData?.ancillaryServices?.sectionTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (educationloan_module_default()).platformDivImg,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: props.pageData?.ancillaryServices?.sectionImageUrl,
                                                            alt: props.pageData?.ancillaryServices?.sectionImageAltTag,
                                                            width: 333.98,
                                                            height: 279.13
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-none d-sm-block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: (educationloan_module_default()).ancillaryServicesTitle,
                                                    children: props.pageData?.ancillaryServices?.sectionTitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: props.pageData?.ancillaryServices?.sectionDescription
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "pl-0",
                                                children: props.pageData?.ancillaryServices?.sectionPoints?.length > 0 && props.pageData?.ancillaryServices?.sectionPoints.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: point
                                                    }, index))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " d-none d-sm-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "platform-images",
                                            className: (educationloan_module_default()).platformDivImg,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: props.pageData?.ancillaryServices?.sectionImageUrl,
                                                alt: props.pageData?.ancillaryServices?.sectionImageAltTag,
                                                width: 490,
                                                height: 440
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "regional-manvedio",
                                    className: (educationloan_module_default()).regionalManVedio,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (educationloan_module_default()).videoTitle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "\xc9LAN Education Loan : Video"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    className: "d-flex justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (educationloan_module_default()).videoContainer,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratio/* default */.Z, {
                                                            aspectRatio: "16x9",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                                                embedClassName: (educationloan_module_default()).mangerVideo,
                                                                tag: "embed",
                                                                type: "image/svg+xml",
                                                                src: props.pageData?.loanEmbedUrl
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (educationloan_module_default()).webinarEventsMianSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                    headingLevel: 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our students love us",
                bgColor: "#FFFFFF",
                slug: `student-testimonials?type=educationloan&_limit=15&_sort=id:DESC`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (educationloan_module_default()).EduLoanLatestKcUpdates,
                children: [
                    props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                        ...props.pageData.videoTestimonial,
                        parentContainerStyles: {
                            marginBottom: "80px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                        ...props
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (educationloan_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                classname: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(props.pageData?.meta?.jotforms[0]?.jotformid)}`
            })
        ]
    });
};
/* harmony default export */ var EduationLoan = (EducationLoan);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/student-services/education-loan-for-overseas-education.tsx




const EducaLoan = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EduationLoan, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var education_loan_for_overseas_education = (EducaLoan);


/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 31171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicBg":"educationloan_dynamicBg__Cd4_t","videoContainer":"educationloan_videoContainer__SOU8j","mangerVideo":"educationloan_mangerVideo__srAFC","mainSectionBg":"educationloan_mainSectionBg___6J_M","contentDiv":"educationloan_contentDiv__SLAEL","servContent":"educationloan_servContent__4YJl8","contentImgGirl":"educationloan_contentImgGirl__CIyj6","home_page_service_div":"educationloan_home_page_service_div__NSSfm","serviceHead":"educationloan_serviceHead__3GtR7","service_content":"educationloan_service_content__Yp17Z","serviceAnchor":"educationloan_serviceAnchor__oe_Jd","service_img_slider":"educationloan_service_img_slider__FA_HU","loanProcesstop":"educationloan_loanProcesstop__Joz0O","mobContent":"educationloan_mobContent__l60YC","multi_country_content":"educationloan_multi_country_content__GNw2r","bomImg":"educationloan_bomImg__kwR0k","loan-div-heading":"educationloan_loan-div-heading__uaab7","titlebom2":"educationloan_titlebom2__bBKTW","loanProcess":"educationloan_loanProcess__nQh4T","centered":"educationloan_centered__bWecZ","span":"educationloan_span__Wftpx","decimals":"educationloan_decimals__1cn4B","webinarEventsMianSection":"educationloan_webinarEventsMianSection__MULsb","homePageLatestKcUpdates":"educationloan_homePageLatestKcUpdates__gS7ai","homePageBlogs":"educationloan_homePageBlogs__1kgoi","WebinarHomeLineImg":"educationloan_WebinarHomeLineImg__XQWhI","uniTieUp":"educationloan_uniTieUp__RkBlL","Strengths":"educationloan_Strengths__74Zz5","sliderDots":"educationloan_sliderDots__rPsXd","slick-slide":"educationloan_slick-slide__z4P9g","slider":"educationloan_slider__vwVrX","bgstudentslove":"educationloan_bgstudentslove__4pZVR","bgsevensteps":"educationloan_bgsevensteps__ffb44","searviceLoan":"educationloan_searviceLoan__551pG","videoTitle":"educationloan_videoTitle__V45dl","PlatformContent":"educationloan_PlatformContent__Bf7nD","ancillaryServicesTitle":"educationloan_ancillaryServicesTitle__rOTwk","viewMore":"educationloan_viewMore__7LjAM","platformDivImg":"educationloan_platformDivImg__5j1lA","studentFooter":"educationloan_studentFooter__oY0Ko","session":"educationloan_session__5GDad","btCenter":"educationloan_btCenter__8turL","EduLoanLatestKcUpdates":"educationloan_EduLoanLatestKcUpdates__cWAp0"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 82908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"studentservices_studentServicesPage__jDBb9","studentServicesCurve":"studentservices_studentServicesCurve__V6eKt","contentDiv":"studentservices_contentDiv__wEbZf","enquirebtn":"studentservices_enquirebtn__ld5mL","servContent":"studentservices_servContent__PL5SN","WhyKc":"studentservices_WhyKc__sZxHm","viewMore":"studentservices_viewMore__bN0nA","img":"studentservices_img__H06y5","studentServicesWebinarEvent":"studentservices_studentServicesWebinarEvent__YR1_a","studentHelpMainDiv":"studentservices_studentHelpMainDiv__1GWsb","studentHelp":"studentservices_studentHelp__1fO7O","alignTop":"studentservices_alignTop__iMtE_","subAnchor":"studentservices_subAnchor__jRKHU","knowMore":"studentservices_knowMore__Y1q7q","linksDiv":"studentservices_linksDiv__KAP9F","studentServicesKcUpdates":"studentservices_studentServicesKcUpdates__LWcWL","StudentBlogs":"studentservices_StudentBlogs__TKFes","studentFooter":"studentservices_studentFooter__C7T7a","session":"studentservices_session__I15Qa","student":"studentservices_student__R_JgR","middelStuTest":"studentservices_middelStuTest__JJpvH","stuTestCard":"studentservices_stuTestCard__s_G5N","cardBody":"studentservices_cardBody__fAO4I","addre":"studentservices_addre__cGp__","studentTestSlider":"studentservices_studentTestSlider__bff6C","sevenBG":"studentservices_sevenBG__ovks8","sliderDots":"studentservices_sliderDots__PrfDo","slick-slide":"studentservices_slick-slide__Zwpji","slick-center":"studentservices_slick-center__42LQ5","arrowsClass":"studentservices_arrowsClass__pblWv","btcircle":"studentservices_btcircle__uDqgR","arrowsClasses":"studentservices_arrowsClasses__SQl3Q"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 54076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js







const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Collapse, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ }),

/***/ 84883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  aspectRatio: '1x1'
};

function toPercent(num) {
  if (num <= 0 || num > 100) return '100%';
  if (num < 1) return `${num * 100}%`;
  return `${num}%`;
}

const Ratio = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  children,
  aspectRatio,
  style,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'ratio');
  const isCustomRatio = typeof aspectRatio === 'number';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    ref: ref,
    ...props,
    style: { ...style,
      ...(isCustomRatio && {
        '--bs-aspect-ratio': toPercent(aspectRatio)
      })
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children)
  });
});
Ratio.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Ratio);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,474,5684,9465,2350,3593,9774,2888,179], function() { return __webpack_exec__(7573); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);